import { FC } from 'react';
import cx from 'classnames';

import { Card } from '../Card';
import { isCardWImage, CardWIcon, CardWImage } from '../types';

import styles from './List.module.scss';

type ListProps = {
  className?: string;
  items: Array<CardWIcon | CardWImage>;
  columns?: number;
  onFocus?: (event: any) => void;
};

export const List: FC<ListProps> = ({ className, items, columns }) => {
  const isImagesGrid = items.some((child) => {
    return isCardWImage(child);
  });

  return (
    <ul
      className={cx(
        styles.List,
        { [styles.List_large]: isImagesGrid },
        { [styles[`List_columns_${columns}`]]: columns },
        className,
      )}
    >
      {items.map((item, i) => {
        return (
          <li key={`main-menu-list-item-${i}-${item.href}`}>
            <Card {...item} tabIndex={-1} />
          </li>
        );
      })}
    </ul>
  );
};
